<template>
  <v-dialog v-model="localDialog" width="auto">
    <v-card
      max-width="400"
      prepend-icon="mdi-tooltip-question-outline"
      :text="localMessage"
      :title="localTitle"
    >
      <template v-slot:actions>
        <v-btn class="ms-auto" text="Cancel" @click="localDialog = false"></v-btn>
        <v-btn class="ms-auto" text="Ok" @click="confirmDialog"></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from 'vue'
import eventBus from '../../eventBus'

export function showDialog(title: string, message: string, namespace: string) {
  eventBus.emit('dialog:show', { title, message, namespace })
}

export default defineComponent({
  name: 'DialogComponent',
  setup() {
    const localDialog = ref(false)
    const localMessage = ref('')
    const localTitle = ref('')
    const namespace = ref('')
    const handleShowDialog = () => {}

    onMounted(() => {
      const handleShowDialog = (event) => {
        localDialog.value = true
        localTitle.value = event.title
        localMessage.value = event.message
        namespace.value = event.namespace
      }
      eventBus.on('dialog:show', handleShowDialog)
    })

    onUnmounted(() => {
      eventBus.off('dialog:show', handleShowDialog)
    })

    const dismissDialog = () => {
      localDialog.value = false
      localTitle.value = ''
      localMessage.value = ''
    }

    const confirmDialog = () => {
      eventBus.emit(`dialog:confirmed_${namespace.value}`)
      dismissDialog()
    }

    return {
      localDialog,
      localTitle,
      localMessage,
      dismissDialog,
      confirmDialog
    }
  }
})
</script>
